import React, { useEffect, useState } from "react";
import {
  ProjectImage,
  ProjectSearchProperties,
} from "../../../interfaces/projects";
import { SearchPropertiesService } from "../../../services/search-properties";
import { scrollToDiv, transformCloudinaryImg } from "../../../services/utils";
import Carousel from "../Carousel";
import Icon from "../Icon";
import InfiniteLoader from "../InfiniteLoader";
import { ScaledText } from "../ScaledText";
import ProjectSearchForm from "./ProjectSearchForm";
import ProjectSearchResult from "./ProjectSearchResult";
import "./projectsSearchProperties.scss";

const ProjectsSearchProperties: React.FC<ProjectSearchProperties> = ({
  colors,
  images,
  project,
  searchForm,
}) => {
  const [properties, setProperties] = useState<any>();
  const [filteredProperties, setFilteredProperties] = useState<any>();
  const [imgs, setImgs] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [opacity, setOpacity] = useState<any>({});
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const { clientWidth } = document.documentElement;

      setImgs(
        images.map((item: ProjectImage) =>
          transformCloudinaryImg(
            item.img,
            clientWidth <= 768 ? "f_auto,q_70,h_400" : "f_auto,q_70,w_1920"
          )
        )
      );
    }
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (typeof window !== `undefined`) {
        const el = document.getElementById("unidades")!;
        // const width = document.documentElement.clientWidth;
        const vh40 = document.documentElement.clientHeight * 0.25;

        // if (
        //   window.pageYOffset - el.offsetTop - (width <= 768 ? 100 : 400) >=
        //   0
        // ) {
        //   console.warn("aca");
        // }

        if (window.pageYOffset - el.offsetTop + vh40 >= 0) {
          const movibleWrap = document.getElementById(
            "movible-wrap-search-properties"
          );
          const movibleEl = document.getElementById(
            "movible-search-properties"
          );
          const opacity =
            ((((movibleEl!.offsetTop +
              movibleEl!.clientHeight -
              document.documentElement.clientHeight * 0.045) *
              100) /
              movibleWrap!.clientHeight -
              100) *
              -1) /
            100;
          const grayscale =
            (((movibleEl!.offsetTop + movibleEl!.clientHeight) * 100) /
              movibleWrap!.clientHeight -
              100 * -1) /
              100 -
            1;

          setOpacity({
            opacity,
            filter: `grayscale(${grayscale > 0.25 ? grayscale : 0})`,
          });
        } else {
          setOpacity({ opacity: 1, filter: `grayscale(${0})` });
        }
      }
    };
    if (typeof window !== `undefined`) {
      window.addEventListener("scroll", onScroll);
    }
    return () => {
      if (typeof window !== `undefined`) {
        return window.removeEventListener("scroll", onScroll);
      }
    };
  }, []);

  // const onSearch = async (filters): Promise<void> => {
  //   setLoading(true);
  //   try {
  //     const data = await SearchPropertiesService.search(project, filters);
  //     setProperties(data);
  //   } catch (err) {
  //     console.warn(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onFilter = (filters) => {
    // console.warn(filters);
    // if (filters.ambientes) {
    //   setFilteredProperties(
    //     properties.filter(({ ambientes }) =>
    //       filters.ambientes === "all" || !filters.ambientes
    //         ? true
    //         : ambientes
    //             .split(",")
    //             .map((item: any) => item.trim())
    //             .includes(`${filters.ambientes}`.trim())
    //     )
    //   );
    //   return;
    // }

    // if (filters.orientacion) {
    //   setFilteredProperties(
    //     properties.filter(({ orientacion }) =>
    //       filters.orientacion === "all" || !filters.orientacion
    //         ? true
    //         : orientacion
    //             .split(",")
    //             .map((item: any) => slugify(item.trim()))
    //             .includes(slugify(filters.orientacion.trim()))
    //     )
    //   );
    //   return;
    // }

    // if (filters.exterior) {
    //   setFilteredProperties(
    //     properties.filter(({ exterior }) =>
    //       filters.exterior === "all" || !filters.exterior
    //         ? true
    //         : exterior
    //             .split(",")
    //             .map((item: any) => slugify(item.trim()))
    //             .includes(slugify(filters.exterior).trim())
    //     )
    //   );
    //   return;
    // }

    setFilteredProperties(
      properties
        .filter(({ ambientes }) =>
          filters.ambientes === "all" || !filters.ambientes
            ? true
            : ambientes
                .split(",")
                .map((item: any) => item.trim())
                .includes(`${filters.ambientes}`.trim())
        )
        .filter(({ orientacion }) =>
          filters.orientacion === "all" || !filters.orientacion
            ? true
            : orientacion
                .split(",")
                .map((item: any) => slugify(item.trim()))
                .includes(slugify(filters.orientacion.trim()))
        )
        .filter(({ exterior }) =>
          filters.exterior === "all" || !filters.exterior
            ? true
            : exterior
                .split(",")
                .map((item: any) => slugify(item.trim()))
                .includes(slugify(filters.exterior).trim())
        )
    );
  };

  const slugify = (string: string): string =>
    string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");

  const getAll = async (): Promise<void> => {
    setLoading(true);
    try {
      scrollToDiv("search-form-container", 1000, 100);
      const data = await SearchPropertiesService.getAll(project);
      setFilteredProperties(data);
      setProperties(data);
    } catch (err) {
      console.warn(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="search-properties" id="unidades">
      <div className="container">
        <div className="movible-wrap" id="movible-wrap-search-properties">
          <div
            className="movible"
            style={opacity}
            id="movible-search-properties"
          >
            <ScaledText text="UNIDADES" />
          </div>
        </div>
      </div>

      {/* <div className="container">
        <h2
          className="section-title text-uppercase font-medium"
          style={{ color: colors.primary }}
        >
          BUSCADOR DE PROPIEDADES
        </h2>
      </div> */}

      <div className="search-properties-carousel">
        <Carousel
          autoPlay={false}
          renderDots={({ setActiveIndex, activeIndex }) => (
            <>
              <div className="carousel-dots">
                {new Array(images.length).fill("").map((_, i) => (
                  <span
                    onClick={() => setActiveIndex(i)}
                    key={i}
                    style={{
                      background: i === activeIndex ? colors.primary : "#fff",
                      opacity: i === activeIndex ? 1 : 0.75,
                    }}
                  ></span>
                ))}
              </div>
              {!filteredProperties?.length ? (
                <div
                  onClick={() => getAll()}
                  className={`button-properties font-bold ${
                    loading ? "disabled" : ""
                  }`}
                  style={
                    {
                      // color: colors.primary,
                      // backgroundColor: colors.secondary,
                    }
                  }
                >
                  Ver Unidades{" "}
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.778 14L9.76508 13.0249L15.1342 7.7L0.861328 7.7L0.861328 6.3L15.1342 6.3L9.76508 0.9989L10.778 0L17.8613 7L10.778 14Z"
                      fill="#E94F1B"
                    />
                  </svg>
                </div>
              ) : null}
            </>
          )}
          renderArrowRight={({ handleNext }) => (
            <div className="arrow-control arrow-right" onClick={handleNext}>
              <Icon name="chevron-right" color="#fff" />
            </div>
          )}
          renderArrowLeft={({ handlePrev }) => (
            <div className="arrow-control arrow-left" onClick={handlePrev}>
              <Icon name="chevron-left" color="#fff" />
            </div>
          )}
          onSlideChange={(index) => setActiveIndex(index)}
          interval={5000}
          activeIndex={activeIndex}
          loop={true}
        >
          {imgs.map((image: string, i: number) => {
            return (
              <img
                key={i}
                className="carousel-item"
                src={image}
                loading="lazy"
              />
            );
          })}
        </Carousel>
      </div>

      <div className="container" id="search-form-container">
        {/* {!filteredProperties?.length ? (
          <div
            onClick={() => getAll()}
            className={`button-properties font-bold text-uppercase ${
              loading ? "disabled" : ""
            }`}
            style={{
              color: colors.primary,
              backgroundColor: colors.secondary,
            }}
          >
            VER UNIDADES
          </div>
        ) : null} */}

        {filteredProperties && filteredProperties.length ? (
          <ProjectSearchForm
            searchForm={searchForm}
            colors={colors}
            properties={filteredProperties}
            allProperties={properties}
            onSearch={(filters) => onFilter(filters)}
          />
        ) : null}

        <div className="properties-result">
          {filteredProperties && filteredProperties.length ? (
            <ProjectSearchResult
              properties={filteredProperties}
              colors={colors}
            />
          ) : null}
          {filteredProperties && !filteredProperties.length && !loading && (
            <div className="not-found font-bold">
              No se encontraron resultados
            </div>
          )}
          {loading && (
            <div
              className={`loader-container ${
                filteredProperties && filteredProperties.length
                  ? "absolute"
                  : ""
              }`}
            >
              <InfiniteLoader />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSearchProperties;
